module.exports = __webpack_public_path__ + "img/chat-green.42ae2220.svg";